import { defineStore } from 'pinia'

interface State {
  isOpen: boolean
}

const INITIAL_STATE: State = {
  isOpen: false,
}

const useMessagesStore = defineStore('messages', {
  state: () => ({ ...INITIAL_STATE }),
  actions: {
    toggleIsOpen(value?: boolean) {
      if (value !== undefined) {
        this.isOpen = value
      } else {
        this.isOpen = !this.isOpen
      }
    },
  },
})

export default useMessagesStore
